/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */
import LocalizedStrings from "react-localization"

export const strings = new LocalizedStrings({
    en: {
        productsAvailablity: "Available worldwide",
        viaOurDistributors: "Brodit products are available via our distributors.",
        pdfFiles: "PDF-files",
        compatibleProducts: "Compatible models",
        back: "Go back",
        showSearch: "Show search area",
        hideSearch: "Hide search area",
        tabInformation: "Information",
        moreInformation: "More information",
        tabSpecification: "Specification",
        tabCompability: "Fits for",
        tabInstructions: "Instructions",
        tabRelatedProducts: "Accessories",
        tabRelatedFiles: "Documents",
        noRelatedFiles: "There are no documents for this product",
        noAccessories: "There are no accessories for this product.",
        thereAreNoVideosForThisProduct: "There are no videos for this product.",
        itemNumber: "Item no",
        loadingMaterial: "Loading material",
        features: "Features",
        fasteners: "Fasteners",
        compabilities: "Fits the following models",
        thisProductIsNotModelSpecific: "This product is not model specific",
        loadingCompabilities: "Loading compabilities",
        loadingProperties: "Loading properties",
        properties: "Properties",
        propertiesNoneExist: "No properties apply to this product.",
        instructions: "Instructions for",
        chargingSpecification: "Charging specifications",
        error: "Error",
        unknownErrorCreatingOrder: "Unknown error creating order.",
        showMore: "Show more",
        showLess: "Show less",
        noMaterialsAssigned: "No features are assigned to this product.",
        comingSoon: "Coming soon",
        loadingProduct: "Loading product",
        createLeaflet: "Create leaflet",
        print: "Print",
        compare: "Compare",
        isComparing: "is being compared",
        share: "Share",
        loading: "Loading",
        image: "Image",
        addToCart: "Add to cart",
        eanNumber: "EAN-number",
        productInformation: "Product information",
        addToFavorites: "Add to favorites",
        removeFromFavorites: "Remove from favorites",
        yourFavorites: "Your favorites",
        hereYouWillFindAllFavoriteProducts: "Here you will find all the products that have been marked as a favorite.",
        newProduct: "New product",
        pickedByPro: "Picked By Pro",
        newProductsForDevices: "New products for devices",
        newProductsForVehicles: "New products for vehicles",
        more: "More",
        moreSmall: "...more",
        close: "Close",
        seeAll: "Show all",
        hits: "hits",
        toggleLanguage: "Toggle language",
        user: "User",
        cart: "Cart",
        toggleView: "Toggle view",
        logIn: "Log in",
        email: "E-mail",
        password: "Password",
        repeatPassword: "Repeat password",
        changePassword: "Change password",
        forgotPassword: "Forgot password",
        passwordsMustMatch: "The passwords must match",
        forgotPasswordNotification: "A mail for resetting the password has been sent to the given email if it exist in our system. The link is vaild for 30min.",
        checkYourLoginDetails: "Check your login details and try again.",
        product: "Product",
        theProduct: "The product",
        hasBeenAddedToCart: "has been added to the cart",
        addressDetails: "Address details",
        confirmation: "Confirmation",
        yourCart: "Your cart",
        checkOrderDetails: "Please check your order carefully to make sure everything is correct.",
        summary: "Summary",
        numberOfOrderLines: "Number of order lines",
        totalQuantity: "Total quantity",
        total: "Total",
        emptyCart: "Empty cart",
        addNote: "Add note",
        note: "Note",
        quantity: "Order qty",
        qty: "Qty",
        price: "Price",
        backToShop: "Back to shop",
        backToCart: "Back to cart",
        toCheckout: "To checkout",
        submitOrder: "Submit order",
        myDetails: "My details",
        customerNumber: "Customer number",
        name: "Name",
        messageToBrodit: "Message to Brodit",
        purchaseOrder: "Purchase order | Marking",
        orderPlacedBy: "Order placed by | Reference",
        emailForOrderConfirmation: "E-mail (for order confirmation)",
        standardShippingAddress: "Standard shipping address",
        billingAddress: "Billing address",
        orderConfirmation: "Order confirmation",
        thankYouForOrder: "Thank you for ordering from Brodit!",
        orderIsProcessing: "Your order is now being processed. You will receive a confirmation via e-mail soon.",
        orderNumber: "Order number",
        orderDate: "Order date",
        orderEmail: "Order e-mail",
        shippingAddress: "Shipping address",
        reference: "Reference", // Kanske inte nödvändig, ett datafält egentligen
        shop: "Shop",
        shopViaReseller: "You can buy Brodit's products via reseller",
        findReseller: "Find reseller",
        becomeReseller: "Become reseller",
        news: "News",
        showMoreNews: "Show news archive",
        couldNotFindTheSelectedNewsArticle: "Could not find the selected news article",
        newHolders: "New holders",
        newProclip: "New ProClip",
        newsLetter: "Newsletter",
        aboutBrodit: "About Brodit",
        broditsStory: "Brodit's story",
        broditsMovie: "Brodit's movie",
        cookies: "Cookies",
        values: "Values",
        policies: "Policies",
        integrityPolicy: "Integrity policy",
        contact: "Contact",
        contactBrodit: "Contact Brodit",
        hello: "Hello",
        contactBroditVia: "Contact Brodit via ",
        ifYouWantToChangeAnyInformation: " if you wish to change any information.",
        hereIsYourUserInfo: "Here is your user info.",
        workAtBrodit: "Work at Brodit",
        findBrodit: "Find Brodit",
        noArticlesInCart: "You have no articles in the cart.",
        yourOrders: "Your orders",
        yourReference: "Your reference",
        registered: "Registered",
        printed: "Printed",
        deliveryTimeCannotBeConfirmed: "Delivery time cannot be confirmed",
        processing: "Processing",
        partiallyDelivered: "Partly dispatched",
        deliveryComplete: "Dispatched",
        date: "Date",
        order: "Order",
        orderWasPlaced: "Order is placed, please check your email for order confirmation.",
        status: "Status",
        track: "Track",
        marking: "Marking",
        numberOfProducts: "Number of products",
        trackShipment: "Track shipment",
        backToOrderList: "Back to order list",
        sentQuantity: "Sent quantity",
        anErrorOccuredTryRelogging: "An error occured. Try logging in again.",
        published: "Published",
        toggleSortOrder: "Toggle sort order",
        sort: "Sort by",
        searchOnDevice: "CHOOSE DEVICE",
        searchOnVehicle: "CHOOSE VEHICLE",
        searchOnModel: "CHOOSE MODEL",
        searchOnModelYears: "CHOOSE YEAR",
        device: "Device",
        vehicle: "Vehicle",
        showImages: "Show more images",
        howToInstall: "How to install",
        phone: "Phone",
        fax: "Fax",
        thisSiteUsesCookies: "This site uses Cookies.",
        readMoreInThePrivacyPolicy: "Read more in the Privacy policy.",
        iAccept: "I accept",
        IHaveReadAndAcceptTheTerms: "I have read and agree to the terms.",
        iHaveReadAndAgreeTo: "I have read and agree to",
        broditABsConditionsAndTermsOfSale: "Brodit ABs conditions and terms of sale",
        information: "Information",
        companyAdress: "Company",
        purchase: "Purchase",
        delivery: "Delivery",
        validate: "Validate",
        cancel: "Cancel",
        register: "Register",
        backwards: "Back",
        next: "Next",
        companyName: "Company name",
        organisationNumber: "Organisation number",
        website: "Website",
        contactPerson: "Contact person",
        phonenumber: "Phone number",
        streetAddress: "Street address",
        postalCode: "Postal code",
        town: "Town",
        boxDeliveryAddress: "Box delivery address",
        deliveryAddress: "Delivery address",
        postalAddress: "Postal address",
        companySignatory: "Company signatory",
        attachUpToDateRegistrationCertificateFromBolagsverketAsAFile: "Attach up to date registration certificate from Bolagsverket (PRV) as a file in PDF-format.",
        chooseAFile: "Choose a file",
        noFileHasBeenSelected: "No file has been selected.",
        pleaseAcceptTheTermsAndConditionsAboveToContinue: "Please accept the terms and conditions above to continue.",
        pleaseFillInThisCheckBox: "Please fill in this check box.",
        sendApplication: "Send application",
        forParcelDelivery: "For parcel delivery",
        forInvoiceThroughPdfBroditOnlySendsInvoicesThroughEmail: "for invoice in PDF format (Brodit only sends invoices through email)",
        yourApplicationHasBeenSent: "Your application has been sent.",
        aProblemOccuredWhileProccessingYourApplication: "A problem occured while proccessing your application.",
        pleaseTryAgainLaterOrContactBroditsSupportIfTheProblemPersists: " Please try again later or contact Brodit if the problem persists.",
        couldNotConnectToTheServer: "Could not connect to the server.",
        aProblemOccuredWhileProccessingYourApplicationPleaseTryAgainLaterOrContactBroditsSupportIfTheProblemPersists: "A problem occured while proccessing your application. Please try again later or contact Brodits support if the problem persists.",
        models: "Models",
        modelYears: "Model years",
        otherModels: "Other models",
        products: "Products",
        loadMore: "Load more",
        searchResults: "Search results",
        youSearchedFor: "You searched for",
        search: "Search",
        searchUpperCase: "SEARCH",
        searchForProducts: "Search for products",
        premiereNewOnlineShop: "Premiere new online shop",
        beforeYouLogInInfo: "Updated shop requires updated password... Reset your password before logging in the first time (use the feature below). Thank you!",
        returnNote: "Return note",
        logOut: "Log out",
        year: "Year",
        chooseYear: "CHOOSE YEAR",
        deselectAll: "DESELECT ALL",
        showOrHideFilters: "Show or hide filters",
        yourEmail: "Your e-mail",
        yourName: "Your name",
        receiversEmail: "Receivers e-mail",
        message: "Message",
        shareThis: "Share this",
        orderByFile: "Order by file",
        orderByFileInfoParagraph1: "For easier order placement you can upload an order-file into our web shop. You can export the file from your own system, and then upload it directly into your cart. This saves you time and eliminates type errors!",
        orderByFileInfoParagraph2: "Specifications: The file must be a comma separated text file. Usually, it is easiest to save your file as a csv-file directly from Excel or similar applications, but any text file will work as long as the numbers are delimited by commas or semi-colons. The file should contain item numbers and quantities only (Column A: Item no, Column B: Quantity)",
        upload: "Upload",
        clearYourCartFirst: "You already have items in your cart. Please clear it to continue.",
        orderWasImported: "Your order is now imported to the cart.",
        errorReadingOrderFile: "There was an error reading the order import file. Please try another file.",
        clear: "Clear",
        chosenFile: "Chosen file",
        notIncludedArticlesMessage: "The following articles are not found or not for sale",
        couldNotBePlacedInCart: "could not be placed in cart, it is not for sale or does not exist.",
        yourPasswordHasBeenChanged: "Your password has been changed.",
        ifYouHaveProblemsWithYourCartResetIt: "If you have problems with your cart, you can click here to reset it.",
        youHaveSharedTheProduct: "You have shared the product.",
        somethingWentWrongWhenSharingProduct: "Something went wrong when sharing the product.",
        recaptchaError: "Something went wrong with Recaptcha.",
        unknownError: "An unknown error occured.",
        articleCouldNotBeAddedQuantityZero: "The article cannot be added with quantity zero.",
        experiencingProblemsWithCart: "Experiencing problems with the cart? ",
        clickHere: "Click here",
        toResetYourCart: " to reset (empty) it.",
        endingSoon: "Ending Soon",
        chooseCity: "CHOOSE CITY",
        shopOnline: "SHOP ONLINE",
        notFound: "Not found",
        thisPageWasNotFoundGoBackTo: "This page was not found. Go to ",
        home: "Mounting platform specialist!",
        phasingOut: "Few left",
        brands: "Brands",
        showAmount: "Show amount",
        yourSearchGenerated: "Your search generated",
        account: "Account",
        fileDownload: "File download",
        yourAccount: "Your account",
        language: "Language",
        english: "English",
        swedish: "Swedish",
        german: "German",
        includePrices: "Include prices",
        updatesOnly: "Updates only",
        newItems: "New items",
        changedItems: "Changed items",
        deletedItems: "Deleted items",
        isDeleted: "Is deleted",
        isDiscontinuedAndNoLongerAvailable: "is discontinued and is no longer available",
        removeAll: "Remove all",
        removeItem: "Remove item",
        youMustChooseAType: "You must choose a type of data.",
        formatShouldBeISO8601: "Format should be YYYY-MM-DD.",
        download: "Download",
        errorWhenAttemptingToDownloadFile: "Error when attempting to download file.",
        type: "Type",
        noContentForTheSelectedLanguage: "No content for the selected language.",
        fromDate: "From date",
        webshopForBroditResellers: "Online shop for Brodit distributors",
        continueShopping: "Continue shopping",
        toSellBroditProducts: "To sell Brodit products",
        retailerApplicationText: `Brodit is represented worldwide via experienced
      and valued distributors. For unrepresented countries, there’s an opening
      for companies who are passionate about service, quality and innovative
      ideas. If that applies to you, please tell us about your current
      business areas as well as your visions for Brodit products in your
      country in an e-mail to exportsales@brodit.se. Thank you!`,
        thisProductIsNotAvailableOrder: "This item is included in your order but you can only see the item number, you can not see the product name or what it fits for.",
        country: "Country",
        useTemporaryAddress: "Send this order to a temporary shipping address",
        zipAndCity: "Zip and city",
        address: "Address",
        productNotFound: "Product not found",
        weCouldNotFindThisProductEtc: "We could not find this product. The product does not exist.",
        forInstanceKarlsborg: "I.e. \"54634 Karlsborg\"",
        asLoggedInUserYouCanWithdraw: "You can withdraw your consent at any time at your user profile or on the Privacy page under Documents.",
        ifYouWantToWithdrawConsent: "If you want to withdraw your constent to cookies, click ",
        here: "here",
        youMustThenAcceptTheTermsAgain: "You must then accept the privacy terms again to be able to sign in.",
        tryResettingPasswordAgain: "It seems like the token is not valid. Try resetting your password again.",
        fileDownloadIsNotAvailable: "File download is under development and is not available for now.",
        displaying: "Displaying",
        outOf: "out of",
        results: "results",
        apiKey: "API key",
        badRequestFileDownload: "Error in input when downloading file. Is API key in correct format?",
        unAuthorizedFileDownload: "Error trying to verify API key when downloading file. Check with Brodit that you are allowed to download file.",
        compareProducts: "Compare products",
        noProductsToCompare: "No products has been added for compare",
        description: "Description",
        placement: "Placement",
        fitsFor: "Fits for",
        technicalInformation: "Technical information",
        dimensionsAndWeight: "Dimensions & weight",
        width: "Width",
        height: "Height",
        depth: "Depth",
        weight: "Weight",
        volume: "Volume",
        yes: "Yes",
        no: "No",
        compareMaxThreeArticles: "You can compare up to three articles at a time.",
        compareMaxTwoArticles: "You can only compare two articles",
        toComparison: "To comparison",
        notApplicable: "Not applicable",
        clearAllProducts: "Clear all products",
        endComparison: "End comparison",
        thisProductIsNoLongerAvailable: "This product is no longer available.",
        parcel: "Parcel",
        orderSystemMaintenance: "Our order system is currently under maintenance. During this time you can't login and use some services on the site. Refresh the page in a while and try again. Sorry for the inconvenience.",
        systemMaintenanceTryAgainLater: "There is currently a system maintenance, please try again later.",
        theProductWasReplacedWithFollowingProductProducts: "The product was replaced by the following product(s).",
        wasReplacedByFollowingArticles: " was replaced by the following articles.",
        itWasReplacedByTheFollowingArticles: "It was replaced by the following articles: ",
        action: "Action",
        unregister: "Unregister",
        save: "Save",
        yourSubscriptionHasBeenUpdated: "Your newsletter subscription has been updated.",
        somethingWentWrong: "Something went wrong.",
        whereCanIBuy: "Where can I buy?",
        thePasswordMustAlsoComplyToTheFollowingRules: "The password must comply to the following rules:",
        containMinimumSixCharacters: "Contain minimum six characters",
        containUpperCaseCharacters: "Contain uppercase characters",
        containLowerCaseCharacters: "Contain lowercase characters",
        containANumber: "Contain a number",
        containAFigure: "Contain a special character",
        productIsNotAvailable: "Product is not available",
        withdrawingCookiesConsent: "Withdrawing cookies consent...",
        redirectingToStartPage: "Redirecting to start page...",
        video: "Video",
        startPage: "landing page",
        maximum30Letters: "This field can contain maximum 30 letters.",
        examplesSpecialCharacters: "Examples of special characters: ",
        areYouSure: "Are you sure?",
        deleteAllConfirmation: "This will delete all products in the cart.",
        exVat: "excl. VAT"
    },
    sv: {
        productsAvailablity: "Finns i hela Sverige",
        viaOurDistributors: "Brodits produkter kan köpas via våra återförsäljare.",
        pdfFiles: "PDF-filer",
        compatibleProducts: "Kompatibla modeller",
        back: "Bakåt",
        showSearch: "Visa sökfält",
        hideSearch: "Dölj sökfält",
        tabInformation: "Information",
        moreInformation: "More information",
        tabSpecification: "Specifikation",
        tabCompability: "Passar till",
        tabInstructions: "Instruktioner",
        tabRelatedProducts: "Tillbehör",
        tabRelatedFiles: "Dokument",
        noRelatedFiles: "Det finns inga dokument för den här produkten",
        noAccessories: "Det finns inga tillbehör för den här produkten",
        thereAreNoVideosForThisProduct: "Det finns inga videoklipp för den här produkten.",
        itemNumber: "Art. nr.",
        loadingMaterial: "Laddar material",
        features: "Funktioner",
        fasteners: "Fästen",
        compabilities: "Passar till följande modeller",
        thisProductIsNotModelSpecific: "Den här produkten är inte modellspecifik",
        loadingCompabilities: "Laddar kompabiliteter",
        loadingProperties: "Laddar egenskaper",
        properties: "Egenskaper",
        propertiesNoneExist: "Inga egenskaper gäller för denna produkt.",
        instructions: "Instruktioner för",
        chargingSpecification: "Laddningsspecifikationer",
        error: "Fel",
        unknownErrorCreatingOrder: "Okänt fel när ordern skapades.",
        showMore: "Visa fler",
        showLess: "Visa färre",
        noMaterialsAssigned: "Inga funktioner är knutna till den här produkten.",
        comingSoon: "Kommer snart",
        loadingProduct: "Laddar produkt",
        createLeaflet: "Skapa broschyr",
        print: "Skriv ut",
        compare: "Jämför",
        isComparing: "blir jämförd",
        share: "Dela",
        loading: "Laddar",
        image: "Bild",
        addToCart: "Lägg i varukorg",
        eanNumber: "EAN-nummer",
        productInformation: "Produktinformation",
        addToFavorites: "Lägg till som favorit",
        removeFromFavorites: "Ta bort från favoriter",
        yourFavorites: "Dina favoriter",
        hereYouWillFindAllFavoriteProducts: "Här hittar du alla produkter som markerats som en favorit.",
        newProduct: "Ny produkt",
        pickedByPro: "Bästsäljare",
        newProductsForDevices: "Nya produkter till enheter",
        newProductsForVehicles: "Nya produkter till fordon",
        more: "Mer",
        moreSmall: "...fler",
        close: "Stäng",
        seeAll: "Visa alla",
        hits: "träffar",
        toggleLanguage: "Växla språk",
        user: "Användare",
        cart: "Varukorg",
        toggleView: "Växla vy",
        logIn: "Logga in",
        email: "E-post",
        password: "Lösenord",
        repeatPassword: "Upprepa lösenordet",
        changePassword: "Ändra lösenord",
        forgotPassword: "Glömt lösenord",
        passwordsMustMatch: "Lösenorden måste matcha",
        forgotPasswordNotification: "Ett återställningsmail har skickats till den angivna e-posten om den finns i systemet. Länken är giltig i 30min.",
        checkYourLoginDetails: "Kontrollera dina login-uppgifter och prova igen.",
        product: "Artikel",
        theProduct: "Artikel",
        hasBeenAddedToCart: "har lagts i varukorgen",
        addressDetails: "Adressuppgifter",
        confirmation: "Bekräftelse",
        yourCart: "Din varukorg",
        checkOrderDetails: "Kontrollera din order noggrant för att vara säker på att allt stämmer.",
        summary: "Sammanställning",
        numberOfOrderLines: "Antal orderrader",
        totalQuantity: "Artiklar totalt",
        total: "Totalt",
        emptyCart: "Töm varukorg",
        addNote: "Lägg till anteckning",
        note: "Notering",
        quantity: "Order antal",
        qty: "Ant",
        price: "Pris",
        backToShop: "Tillbaka to affär",
        backToCart: "Tillbaka till varukorg",
        toCheckout: "Till kassan",
        submitOrder: "Skicka order",
        myDetails: "Mina uppgifter",
        customerNumber: "Kundnummer",
        name: "Namn",
        messageToBrodit: "Meddelande till Brodit",
        purchaseOrder: "Inköpsorder | Märkning",
        orderPlacedBy: "Order lagd av | Referens",
        emailForOrderConfirmation: "E-post (för orderbekräftelse)",
        standardShippingAddress: "Förvald leveransadress",
        billingAddress: "Fakturaadress",
        orderConfirmation: "Orderbekräftelse",
        thankYouForOrder: "Tack för att du beställer från Brodit!",
        orderIsProcessing: "Din order behandlas. Du kommer få en bekräftelse via e-post snart.",
        orderNumber: "Ordernummer",
        orderDate: "Orderdatum",
        orderEmail: "E-post för order",
        shippingAddress: "Leveransadress",
        reference: "Referens", // Kanske inte nödvändig, ett datafält egentligen
        shop: "Handla",
        shopViaReseller: "Du kan köpa Brodits produkter via återförsäljare",
        findReseller: "Hitta återförsäljare",
        becomeReseller: "Bli återförsäljare",
        news: "Nyheter",
        showMoreNews: "Visa nyhetsarkiv",
        couldNotFindTheSelectedNewsArticle: "Kunde inte hitta den valda nyhetsartikeln",
        newHolders: "Nya hållare",
        newProclip: "Nya ProClip",
        newsLetter: "Nyhetsbrev",
        aboutBrodit: "Om Brodit",
        broditsStory: "Historien om Brodit",
        broditsMovie: "Filmen om Brodit",
        cookies: "Kakor",
        values: "Värdegrund",
        policies: "Policy",
        integrityPolicy: "Integritetspolicy",
        contact: "Kontakt",
        contactBrodit: "Kontakta Brodit",
        hello: "Hej",
        contactBroditVia: "Kontakta Brodit via ",
        ifYouWantToChangeAnyInformation: " om du vill ändra någon information.",
        hereIsYourUserInfo: "Här hittar du information kring din användare.",
        workAtBrodit: "Jobba på Brodit",
        findBrodit: "Hitta till Brodit",
        noArticlesInCart: "Du har inga artiklar i varukorgen.",
        yourOrders: "Dina beställningar",
        yourReference: "Er referens",
        registered: "Registrerad",
        printed: "Utskriven",
        deliveryTimeCannotBeConfirmed: "Leveranstid kan ej bekräftas",
        processing: "Bearbetas",
        partiallyDelivered: "Delvis skickad",
        deliveryComplete: "Skickad",
        date: "Datum",
        order: "Beställning",
        orderWasPlaced: "Ordern är lagd, vänligen kontrollera din e-post efter orderbekräftelsen.",
        status: "Status",
        track: "Spåra",
        marking: "Märkning",
        numberOfProducts: "Antal produkter",
        trackShipment: "Spåra leverans",
        backToOrderList: "Tillbaka till orderlistan",
        sentQuantity: "Skickat antal",
        anErrorOccuredTryRelogging: "Ett fel inträffade. Testa att logga in på nytt.",
        phone: "Telefon",
        fax: "Fax",
        published: "Publicerad",
        showImages: "Visa mer bilder",
        toggleSortOrder: "Växla sorteringsordning",
        sort: "Sortera på",
        searchOnDevice: "VÄLJ ENHET",
        searchOnVehicle: "VÄLJ FORDON",
        searchOnModel: "VÄLJ MODELL",
        searchOnModelYears: "VÄLJ ÅR",
        device: "Enhet",
        vehicle: "Fordon",
        howToInstall: "Så monterar du",
        thisSiteUsesCookies: "Denna webbplats använder Cookies.",
        readMoreInThePrivacyPolicy: "Läs mer i vår integritetspolicy.",
        iAccept: "Jag accepterar",
        IHaveReadAndAcceptTheTerms: "Jag har läst och godkänner villkoren.",
        iHaveReadAndAgreeTo: "Jag har tagit del av och accepterat",
        broditABsConditionsAndTermsOfSale: "Brodit ABs försäljningsvillkor",
        information: "Information",
        companyAdress: "Företag",
        purchase: "Inköp",
        delivery: "Leveransadress",
        validate: "Validera",
        cancel: "Avbryt",
        backwards: "Tillbaka",
        next: "Nästa",
        companyName: "Företagsnamn",
        organisationNumber: "Organisationnummer",
        website: "Hemsida",
        contactPerson: "Kontaktperson",
        phonenumber: "Telefonnummer",
        streetAddress: "Gatuadress",
        postalCode: "Postnr",
        town: "Ort",
        boxDeliveryAddress: "Boxadress",
        deliveryAddress: "Leveransadress",
        postalAddress: "Postadress",
        companySignatory: "Firmatecknare",
        attachUpToDateRegistrationCertificateFromBolagsverketAsAFile: "Bifoga aktuellt registreringsbevis från Bolagsverket (PRV) som fil i PDF-format.",
        chooseAFile: "Välj fil",
        noFileHasBeenSelected: "Ingen fil har valts.",
        pleaseAcceptTheTermsAndConditionsAboveToContinue: "Vänligen acceptera vilkoren ovan för att fortsätta.",
        pleaseFillInThisCheckBox: "Vänligen fyll i denna kryssrutan.",
        sendApplication: "Skicka ansökan",
        forParcelDelivery: "För paketleverans",
        forInvoiceThroughPdfBroditOnlySendsInvoicesThroughEmail: "för faktura via PDF (Brodit skickar endast faktura via E-post)",
        yourApplicationHasBeenSent: "Din ansökan har skickats.",
        aProblemOccuredWhileProccessingYourApplication: "Ett problem uppstod när din ansökan skulle behandlas.",
        pleaseTryAgainLaterOrContactBroditsSupportIfTheProblemPersists: "Vänligen försök igen senare eller kontakta Brodit ifall problemet kvarstår.",
        couldNotConnectToTheServer: "Det gick inte att ansluta till servern.",
        aProblemOccuredWhileProccessingYourApplicationPleaseTryAgainLaterOrContactBroditsSupportIfTheProblemPersists: "Ett problem uppstod när din ansökan skulle behandlas. Vänligen försök igen senare eller kontakta Brodits support ifall problemet kvarstår.",
        models: "Modeller",
        modelYears: "Årsmodell",
        otherModels: "Övriga modeller",
        products: "Produkter",
        loadMore: "Ladda fler",
        searchResults: "Sökresultat",
        youSearchedFor: "Du sökte efter",
        search: "Sök",
        searchUpperCase: "SÖK",
        searchForProducts: "Sök efter produkter",
        premiereNewOnlineShop: "Premiär ny webshop",
        beforeYouLogInInfo: "Uppdaterad shop kräver uppdaterat lösenord! Återställ ditt lösenord innan du loggar in första gången (använd funktionen nedan). Tack!",
        returnNote: "Retursedel",
        logOut: "Logga ut",
        year: "År",
        chooseYear: "VÄLJ ÅR",
        deselectAll: "AVMARKERA ALLA",
        showOrHideFilters: "Visa eller dölj filter",
        yourEmail: "Din e-post",
        yourName: "Ditt namn",
        receiversEmail: "Mottagarens e-post",
        message: "Meddelande",
        shareThis: "Dela detta",
        orderByFile: "Order via fil",
        orderByFileInfoParagraph1: "För enklare orderläggning kan du läsa in en orderfil i vår webshop. Du kan exportera filen från ditt eget system, och ladda upp den direkt i din varukorg så slipper du knappa in ordern manuellt. Snabbt och bekvämt!",
        orderByFileInfoParagraph2: "Specifikationer: Filen skall vara en kommaseparerad textfil. Det enklaste är att välja att spara filen i csv-format i Excel eller liknande progam, men vilken textfil som helst fungerar så länge siffrorna är avgränsade med komma eller semikolon. Filen ska endast innehålla artikelnummer och antal (Kolumn A: Artikelnummer, Kolumn B: Antal).",
        upload: "Ladda upp",
        clearYourCartFirst: "Du har redan artiklar i varukorgen. Vänligen rensa den innan du fortsätter.",
        orderWasImported: "Ordern är nu importerad till varukorgen.",
        errorReadingOrderFile: "Det uppstod ett fel när orderfilen lästes in. Försök med en annan fil.",
        clear: "Rensa",
        chosenFile: "Vald fil",
        notIncludedArticlesMessage: "Följande artiklar kunde inte hittas eller är inte till försäljning",
        couldNotBePlacedInCart: "kunde inte läggas i varukorgen, den är inte till salu eller finns inte",
        yourPasswordHasBeenChanged: "Ditt lösenord har ändrats.",
        ifYouHaveProblemsWithYourCartResetIt: "Om du har problem med varukorgen kan du klicka här för att återställa den.",
        youHaveSharedTheProduct: "Du har delat produkten.",
        somethingWentWrongWhenSharingProduct: "Någonting gick fel när produkten skulle delas.",
        recaptchaError: "Någonting gick fel med Recaptcha.",
        unknownError: "Ett okänt fel uppstod.",
        articleCouldNotBeAddedQuantityZero: "Artikeln kan inte läggas till med noll i antal.",
        experiencingProblemsWithCart: "Upplever du problem med varukorgen? ",
        clickHere: "Klicka här",
        toResetYourCart: " för att återställa (tömma) den.",
        endingSoon: "Utgående",
        chooseCity: "VÄLJ STAD",
        shopOnline: "HANDLA ONLINE",
        notFound: "Sidan hittas inte",
        thisPageWasNotFoundGoBackTo: "Sidan kunde inte hittas. Gå till ",
        home: "Specialisten på monteringsplattformar!",
        phasingOut: "Få kvar",
        brands: "Märken",
        showAmount: "Visa antal",
        yourSearchGenerated: "Din sökning genererade",
        account: "Konto",
        fileDownload: "Filnedladdning",
        yourAccount: "Ditt konto",
        language: "Språk",
        english: "Engelska",
        swedish: "Svenska",
        german: "Tyska",
        includePrices: "Inkludera priser",
        updatesOnly: "Endast uppdateringar",
        newItems: "Nya produkter",
        changedItems: "Ändrade produkter",
        deletedItems: "Borttagna produkter",
        isDeleted: "Är borttagna",
        isDiscontinuedAndNoLongerAvailable: "har utgått ur sortimentet",
        removeAll: "Ta bort alla",
        removeItem: "Ta bort produkt",
        youMustChooseAType: "Du måste välja en typ av data.",
        formatShouldBeISO8601: "Formatet måste vara YYYY-MM-DD.",
        download: "Ladda ner",
        errorWhenAttemptingToDownloadFile: "Ett fel uppstod då filen skulle laddas ner.",
        type: "Typ",
        noContentForTheSelectedLanguage: "Inget innehåll för det valda språket.",
        fromDate: "Från datum",
        webshopForBroditResellers: "Webshop för Brodits återförsäljare",
        continueShopping: "Fortsätt handla",
        toSellBroditProducts: "Att sälja Brodits produkter",
        retailerApplicationText: `Brodit representeras i hela Sverige av kunniga och uppskattade återförsäljare.
    Om du brinner för service, kvalitet, problemlösning och vill arbeta aktivt med
    Brodits produkter, fyll gärna i dina uppgifter nedan så kontaktar vi dig. Tack!`,
        thisProductIsNotAvailableOrder: "Den här produkten är med på din order men du kan endast se artikelnumret, du kan inte se produktens namn eller vad den passar till.",
        country: "Land",
        useTemporaryAddress: "Skicka denna order till en tillfällig leveransadress. Kostnad 35 kr exkl moms.",
        zipAndCity: "Postnummer och ort",
        address: "Adress",
        productNotFound: "Produkten hittades inte",
        weCouldNotFindThisProductEtc: "Vi kunde inte hitta den här produkten. Produkten finns inte.",
        forInstanceKarlsborg: "T.ex. \"54634 Karlsborg\"",
        asLoggedInUserYouCanWithdraw: "Som inloggad användare kan du när som helst ångra ditt samtycke genom länken i din profil eller på sidan Integritet under Dokument.",
        ifYouWantToWithdrawConsent: "Om du vill ångra ditt samtycke till cookies kan du klicka ",
        here: "här",
        youMustThenAcceptTheTermsAgain: "Du måste då åter acceptera villkoren för att kunna använda sidan i inloggat läge.",
        tryResettingPasswordAgain: "Det verkar som länken inte stämmer. Försök återställa ditt lösenord igen.",
        fileDownloadIsNotAvailable: "Filnedladdning är under utveckling och är därför inte tillgängligt just nu.",
        displaying: "Visar",
        outOf: "av",
        results: "resultat",
        apiKey: "API nyckel",
        badRequestFileDownload: "Fel i indata vid filnedladdning. Är API-nyckeln i korrekt format?",
        unAuthorizedFileDownload: "Fel vid verifiering av API-nyckel. Kontrollera med Brodit att du är behörig för filnedladdning.",
        compareProducts: "Jämför produkter",
        noProductsToCompare: "Inga artiklar har lagts till i jämförelse",
        description: "Beskrivning",
        placement: "Placering",
        fitsFor: "Passar till",
        technicalInformation: "Teknisk information",
        dimensionsAndWeight: "Dimensioner & vikt",
        width: "Bredd",
        height: "Höjd",
        depth: "Djup",
        weight: "Vikt",
        volume: "Volym",
        yes: "Ja",
        no: "Nej",
        compareMaxThreeArticles: "Du kan jämföra upp till tre artiklar samtidigt.",
        compareMaxTwoArticles: "Du kan endast jämföra två artiklar samtidigt.",
        toComparison: "Till jämförelsen",
        notApplicable: "Inte tillämpbar",
        clearAllProducts: "Rensa alla produkter",
        endComparison: "Avsluta jämförelse",
        thisProductIsNoLongerAvailable: "Denna produkt är inte längre tillgänglig.",
        parcel: "Försändelse",
        orderSystemMaintenance: "Vårt ordersystem underhålls för närvarande. Under denna tid kan du inte logga in och använda vissa tjänster på webbplatsen. Uppdatera sidan om ett tag och försök igen. Vi beklagar om detta orsakar problem.",
        systemMaintenanceTryAgainLater: "För närvarande systemunderhåll, prova igen senare.",
        theProductWasReplacedWithFollowingProductProducts: "Produkten är ersatt med följande produkt(er).",
        wasReplacedByFollowingArticles: " har blivit ersatt av följande artiklar.",
        itWasReplacedByTheFollowingArticles: "Den är ersatt av följande artiklar: ",
        action: "Åtgärd",
        register: "Prenumerara",
        unregister: "Avprenumerera",
        save: "Spara",
        yourSubscriptionHasBeenUpdated: "Din nyhetsprenumeration har uppdaterats.",
        somethingWentWrong: "Någonting gick fel.",
        whereCanIBuy: "Var kan jag köpa?",
        thePasswordMustAlsoComplyToTheFollowingRules: "Lösenorder måste uppfylla följande krav: ",
        containMinimumSixCharacters: "Innehålla minst sex tecken",
        containUpperCaseCharacters: "Innehålla versaler",
        containLowerCaseCharacters: "Innehålla gemener",
        containANumber: "Innehålla en siffra",
        containAFigure: "Innehålla minst ett specialtecken",
        productIsNotAvailable: "Produkten finns inte tillgänglig",
        withdrawingCookiesConsent: "Ångrar samtycke till cookies...",
        redirectingToStartPage: "Omdirigeras till startsidan...",
        video: "Video",
        startPage: "start sidan",
        maximum30Letters: "Det här fältet kan innehålla maximalt 30 tecken.",
        examplesSpecialCharacters: "Exempel på specialtecken: ",
        areYouSure: "Är du säker?",
        deleteAllConfirmation: "Detta kommer ta bort alla produkter i varukorgen.",
        exVat: "exkl. moms"
    }
})
